module.exports = __webpack_public_path__ + "img/abc-cover.b322222e.png";